import http from "@/shared/services/http";
import {FreightServiceParams} from "@/modules/freightservices/params";

export const createFreightService = (data: any) => http.post(`v1/services`, data);
export const listFreightService = (params?: FreightServiceParams) => http.get(`v1/services`, { params });
export const listFreightServiceCustomer = (params?: any) => http.get(`v1/customer/services`, { params });
export const singleFreightService = (id: string) => http.get(`v1/services/${id}`);
export const updateFreightService = (id: string, data: any) => http.put(`v1/services/${id}`, data);
export const deleteFreightService = (id: string) => http.delete(`v1/services/${id}`);